<template>
  <section>
    <div class="header">
      <div class="btn">
        <div class="popover">
          <v-button
            gray
            @click="handleSubscribe">Subscribe QR Codes</v-button>
          <div
            v-show="showCodeList"
            class="code_list">
            <ul>
              <li @click="createCode">Create QR Code</li>
            </ul>
            <div class="active_title">Active QR Codes</div>
            <ul>
              <li
                v-for="(item, i) in codeList"
                :key="i"
                @click="showQrcCode(item)">
                {{item.period}}
              </li>
            </ul>
          </div>
        </div>
        <v-button
          :disabled="tableData.length == 0"
          gray
          @click="handleExport">Export</v-button>
      </div>
      <div class="search">
        <v-input
          v-model="search"
          :prefixIcon="'el-icon-search'"
          placeholder="Ref., Customer Name, Phone No."
          @keyEnter="filterData" />
      </div>
      <div class="filter">
        <div class="item">
          <span class="item_name">Created</span>
          <v-date-picker
            v-model="filterTime"
            type="daterange"
            @change="filterData"></v-date-picker>
        </div>
        <div class="item">
          <span class="item_name">Session</span>
          <v-select
            v-model="lecture_session"
            clearable
            valueKey="date"
            :list="specialOptions.lecture_session"
            @change="filterData"></v-select>
        </div>
      </div>
    </div>
    <div class="main">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-row-class-name="'tableHeader'"
        @row-click="rowClick">
        <el-table-column
          width="69px"
          align="center">
          <template>
            <div class="flex-algin">
              <p class="icon">
                <font-awesome-icon
                  icon="calendar-check"/>
              </p>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          width="110px"
          label="Date">
          <template #default="{ row }">
            <div class="flex-column time">
              <span>{{ row.created_at.split(" ")[0] }}</span>
              <span> {{ row.created_at.split(" ")[1] }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Name">
          <template #default="{row}">
            <div class="flex-column">
              <span>{{row.isrd_nm}}</span>
              <span class="mobile">{{row.mobile_no}}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="Email"
          prop="email">
        </el-table-column>

        <el-table-column
          label="Session"
          width="180px"
          prop="lecture_session_language">
        </el-table-column>
      </el-table>
    </div>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />

    <!-- dialog -->
    <v-dialog
      v-model="showCreateDialog"
      width="400px">
      <div class="dialog-container">
        <div class="dialog-header">
          <p>Create QR Code</p>
          <font-awesome-icon
            icon="times"
            class="pointer"
            @click="handleShowDialog(false)"></font-awesome-icon>
        </div>
        <div class="dialog-body">
          <el-form
            ref="codeForm"
            :model="codeData"
            :rules="rules">
            <el-form-item prop="accessibleTime">
              <span class="name">Accessible Period</span>
              <v-datetime-picker
                v-model="codeData.accessibleTime"
                type="datetimerange"></v-datetime-picker>
            </el-form-item>
          </el-form>
          <div class="btn-list">
            <v-button
              gray
              @click="handleShowDialog(false)">Cancel</v-button>
            <v-button
              green
              @click="handleNext">Next</v-button>
          </div>
        </div>
      </div>
    </v-dialog>

    <qr-code
      ref="qrCode"
      :codeID="codeID"
      :codeUrl="codeUrl"
      @disableCode="disableCode"></qr-code>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {getRefferTalksList, getQrCodeList, addQrCode, delQrCode} from '@/api/micropolicy'
import QrCode from './dialog/qr-code.vue'
import {downloadFile} from '@/utils/download'
import {mapActions, mapState} from 'vuex'

export default {
  name: 'ReferrerTalksList',
  components:{
    QrCode
  },
  mixins: [MixinOptions],
  data () {
    return {
      search: '',
      filterTime: [],
      lecture_session: '',
      is_export: 0,
      pageConfig: {
        currentPage: 1,
        total: 10,
      },
      tableData: [],
      codeData: {
        accessibleTime: []
      },
      rules:{
        accessibleTime: [
          {required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur']}
        ]
      },
      codeList: [],
      showCodeList: false,
      showCreateDialog: false,
      codeUrl: '',
      codeID: 0
    }
  },
  computed:{
    ...mapState('filter', ['selectFilterData']),
  },
  watch:{
    'selectFilterData.referreTalk':{
      immediate: true,
      deep: true,
      handler(val){
        if(val){
          Object.keys(val).forEach(item=>{
            this[item] = val[item]
          })
          this.getList()
        }
      }
    }
  },
  mounted(){
    this.getList()
    let _this = this
    document.addEventListener('click',function(e){
      if(e.target.offsetParent == null || e.target.offsetParent.className != 'code_list' && e.target.offsetParent.className != 'popover'){
        _this.showCodeList = false
      }
    })
  },
  methods: {
    ...mapActions('filter', ['setFilterData']),
    createCode(){
      this.showCreateDialog = true
    },
    handleShowDialog(val){
      this.showCreateDialog = val
    },
    handleNext(){
      this.$refs['codeForm'].validate(valid => {
        if(valid){
          let params = {
            cmnt_dt: this.codeData.accessibleTime[0],
            expry_dt: this.codeData.accessibleTime[1],
          }
          this.network().addQrCode(params)
        }
      })
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.getList()
    },
    filterData(){
      this.pageConfig.currentPage = 1
      this.getList()
    },
    handleExport(){
      this.is_export = 1
      this.getList()
    },
    getList(){
      let params = {
        search: this.search,
        created_start: this.filterTime[0],
        created_end: this.filterTime[1],
        is_export: this.is_export,
        lecture_session_date: this.lecture_session,
        page: this.pageConfig.currentPage,
      }
      this.network().getRefferTalksList(params)
    },
    rowClick(row){
      let params = {
        search: this.search,
        created_start: this.filterTime[0],
        created_end: this.filterTime[1],
        is_export: this.is_export,
        lecture_session_date: this.lecture_session,
        page: this.pageConfig.currentPage,
      }
      this.setFilterData({referreTalk: params})
      this.$router.push({
        name: 'ReferrerTalksDetail',
        query: {
          id: row.id
        }
      })
    },
    handleSubscribe(){
      this.network().getQrCodeList()
      this.showCodeList = true
    },
    showQrcCode(item){
      const {url, id} = item
      this.codeUrl = url
      this.codeID = id
      this.$refs['qrCode'].changeDialog()
    },
    disableCode(id){
      let params = {
        id
      }
      this.network().delQrCode(params)
    },
    network(){
      return {
        getRefferTalksList: async(params) =>{
          if(this.is_export == 1){
            const res = await getRefferTalksList(params ,{
              responseType: 'blob',
              timeout: 120000
            })
            this.is_export = 0
            downloadFile(res)
          }else{
            const {data} = await getRefferTalksList(params)
            this.tableData = data.data
            this.pageConfig.total = data.total
          }
        },
        getQrCodeList: async() => {
          const {data} = await getQrCodeList()
          this.codeList = data
        },
        addQrCode: async(params) => {
          const {data} = await addQrCode(params)
          this.showCreateDialog = false
          this.codeUrl = data.url
          this.codeID = data.id
          this.$refs['qrCode'].changeDialog()
        },
        delQrCode: async(params) => {
          const {data} = await delQrCode(params)
          if(data.code == 1000){
            this.$message({
              type: 'success',
              message: data.message_language
            })
            this.$refs['qrCode'].changeDialog()
          }
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.header{
  .btn{
    text-align: right;
    .popover{
      display: inline-block;
      margin-right: 10px;
      position: relative;
      .code_list{
        width: 345px;
        position: absolute;
        z-index: 10;
        right: 0;
        margin-top: 10px;
        background: #FFFFFF;
        box-shadow: 0px 8px 24px rgba(66, 74, 83, 0.12), 0px 1px 3px rgba(27, 31, 36, 0.12);
        border-radius: 12px;
        text-align: left;
        ul{
          list-style-type: none;
          padding: 8px;
          li{
            height: 20px;
            box-sizing: content-box;
            padding: 6px 8px;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #24292F;
            border-radius: 6px;
            cursor: pointer;
            &:hover{
              background: rgba(208, 215, 222, 0.32);
            }
          }
        }
        .active_title{
          background: #F6F8FA;
          box-shadow: inset 0px 1px 0px #E1E4E8, inset 0px -1px 0px #E1E4E8;
          height: 20px;
          box-sizing: content-box;
          color: #57606A;
          padding: 7px 16px;
          font-weight: 600;
          font-size: 12px;
          line-height: 18px;
          height: 18px;
          cursor: default;
        }
      }
    }
  }
  .search{
    margin: 20px 0 30px 0;
    height: 32px;
    .el-input{
      height: 32px;
      box-shadow: inset 0px 1px 2px rgba(27, 31, 35, 0.075);
      border-radius: 6px;
    }
  }
  .filter{
    display: flex;
    padding: 15px;
    border: 1px solid #D1D5DA;
    border-radius: 5px;
    background: #FFFFFF;
    .item{
      width: 220px;
      height: 60px;
      .item_name{
        font-weight: 600;
        font-size: 14px;
        color: #24292E;
        margin-bottom: 8px;
        display: block;
      }
      &+.item{
        margin-left: 20px;
      }
    }
  }
}
.main{
  margin-top: 30px;
  /deep/.el-table{
    border-radius: 4px;
    border: 1px solid #E1E4E8;
    font-weight: 400;
    font-size: 14px;
    color: #24292E;
    tr{
      td{
        padding: 10px 15px 10px 0!important;
        vertical-align: top;
        margin-right: 15px;
      .cell{
        line-height: 23px;
        position: relative;
        height: inherit;
        padding: 0;
      }
      }
    }
  }
  /deep/.tableHeader {
    margin-top: 30px;
    background: #F6F8FA !important;
    border-bottom: 1px solid #E1E4E8;
    th {
      background-color: #F6F8FA !important;
      font-family: Inter;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: -0.15px;
      /* Text/text-gray-dark */
      padding: 10px 0!important;
      color: #24292E!important;
      .cell{
        padding-left: 0;
      }
    }
  }
  .icon{
    color: #6A737D;
  }
  .time{
    font-size: 12px;
  }
  .mobile{
    color: #6A737D;
    font-size: 12px;
  }
}
.dialog-container{
  .dialog-header{
    height: 20px;
    padding: 16px;
    box-sizing: content-box;
    display: flex;
    justify-content: space-between;
    background: #F6F8FA;
    border: 1px solid #E1E4E8;
    border-radius: 6px 6px 0px 0px;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #1B1F23;
  }
  .dialog-body{
    padding: 20px 15px 15px 15px;
    .name{
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: #24292E;
      margin-bottom: 8px;
      display: block;
    }
    /deep/.el-date-editor{
      width: 100%;
    }
    .btn-list{
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>
